import React, { useState } from "react";
import { Typography, TextField, IconButton, Tooltip } from "@mui/material";
import MessageThreadList from "./MessageThreadList";

import { Box, Stack } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { crossIcon, crossIconDiv } from "../../../assets/commonFunction";
import useAppSelectors from "../../../customHooks/useAppSelectors";
import { useDispatch, useSelector } from "react-redux";
import { handleRenameThread } from "../../../appStore/actions/ArkchatGroup/action";

const classes = {
  drawerBody: {
    minWidth: "31.25rem",
    maxWidth: "31.25rem",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  header: {
    backgroundColor: "#F9F8F8",
    color: "#0000",
    padding: "0 0.6rem",
    minHeight: "38px",
    flexShrink: 0,
  },
  iconDiv: crossIconDiv,
  iconn: crossIcon,
};

const MessageThreadDrawer = ({
  setMessageThreadOpen,
  setMediaFilesOpen,
  setReplyParentMsg,
  handlegetThreadMessages,
  handleBacktoMessage,
  setMoveTopicTriggered,
  setMoveTopicMsgId,
  setisTopicOpen,
  handleReadStatusDrawer,
  handleSendTempMsg,
  handleClickTaskUpdate,
  isTopicOpen,
  progress,
  isSearchGroupInfoOpen,
  handleSearch,
  handleAddgroupMember,
  isPrivateChatOn,
  searchInputValue,
  handleSearchInputChange,
  highlightText,
  filteredMessageList,
  chatInputControl,
  onPreviewFile,
}) => {
  const dispatch = useDispatch();
  const { selectedGroup, messageList } = useAppSelectors();
  const threadMsgList = useSelector((state) => state?.arkchatgroup?.threadMsgList);

  const parent = threadMsgList?.find((msg) => msg?.thread_id === null) || null;

  const [isEditing, setIsEditing] = useState(false);
  const [headingInput, setHeadingInput] = useState("");

  const handleEditStart = () => {
    setHeadingInput(parent?.thread_heading || "");
    setIsEditing(true);
  };

  const handleEditCancel = () => {
    setIsEditing(false);
    setHeadingInput("");
  };

  const handleEditSave = async () => {
    if (!parent?.id) return;
    await dispatch(handleRenameThread(parent.id, headingInput.trim()));
    setIsEditing(false);
    setHeadingInput("");
  };

  const threadLabel = parent
    ? (parent.thread_heading ? `# ${parent.thread_number} - ${parent.thread_heading}` : `# Thread ${parent.thread_number ?? ""}`)
    : "Message Thread";

  return (
    <Box sx={classes?.drawerBody}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={classes.header}
      >
        <Stack direction="row" alignItems="center" spacing={2} sx={{ flex: 1, minWidth: 0 }}>
          <Typography sx={classes.iconDiv}>
            <CloseIcon
              sx={classes.iconn}
              onClick={() => setMessageThreadOpen(false)}
            />
          </Typography>

          {isEditing ? (
            <Stack direction="row" alignItems="center" spacing={1} sx={{ flex: 1, minWidth: 0 }}>
              <TextField
                size="small"
                autoFocus
                value={headingInput}
                onChange={(e) => setHeadingInput(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleEditSave();
                  if (e.key === "Escape") handleEditCancel();
                }}
                placeholder="Thread heading..."
                sx={{
                  flex: 1,
                  "& .MuiInputBase-input": { fontSize: "0.85rem", padding: "4px 8px" },
                }}
              />
              <Tooltip title="Save">
                <IconButton size="small" onClick={handleEditSave} sx={{ color: "#888" }}>
                  <CheckIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Cancel">
                <IconButton size="small" onClick={handleEditCancel} sx={{ color: "#888" }}>
                  <CloseRoundedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Stack>
          ) : (
            <Stack direction="row" alignItems="center" spacing={0.5} sx={{ flex: 1, minWidth: 0 }}>
              <Typography
                color="black"
                sx={{
                  fontWeight: 500,
                  fontSize: "0.9rem",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {threadLabel}
              </Typography>
              {parent && (
                <Tooltip title="Edit heading">
                  <IconButton size="small" onClick={handleEditStart} sx={{ color: "#888", flexShrink: 0 }}>
                    <EditIcon sx={{ fontSize: "0.9rem" }} />
                  </IconButton>
                </Tooltip>
              )}
            </Stack>
          )}
        </Stack>
      </Stack>

      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden", padding: "0.5rem 19px 0px 12px" }}>
        <Box sx={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
          <MessageThreadList
            messageList={selectedGroup ? messageList : []}
            setMediaFilesOpen={setMediaFilesOpen}
            setReplyParentMsg={setReplyParentMsg}
            handlegetThreadMessages={handlegetThreadMessages}
            handleBacktoMessage={handleBacktoMessage}
            setMoveTopicTriggered={setMoveTopicTriggered}
            setMoveTopicMsgId={setMoveTopicMsgId}
            setisTopicOpen={setisTopicOpen}
            handleReadStatusDrawer={handleReadStatusDrawer}
            handleSendTempMsg={handleSendTempMsg}
            handleClickTaskUpdate={handleClickTaskUpdate}
            isTopicOpen={isTopicOpen}
            progress={progress}
            isSearchGroupInfoOpen={isSearchGroupInfoOpen}
            handleSearch={handleSearch}
            handleAddgroupMember={handleAddgroupMember}
            isPrivateChatOn={isPrivateChatOn}
            searchInputValue={searchInputValue}
            handleSearchInputChange={handleSearchInputChange}
            highlightText={highlightText}
            filteredMessageList={filteredMessageList}
            onPreviewFile={onPreviewFile}
          />
        </Box>

        <Box sx={{ flexShrink: 0 }}>{chatInputControl({ hideSuggestBtn: false })}</Box>
      </Box>
    </Box>
  );
};

export default MessageThreadDrawer;
